import { CustomPageHeader, Text } from '@src/components';
import UserFilter from './UserFilter';
import UserList from './UserList';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'antd';
import { useEffect } from 'react';
import { userByFilterList } from '@src/store/slice/custUsersSlice';

const ManagementUser = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { selectedCustomer } = useSelector((state) => state?.customer);

  useEffect(() => {
    const body = {
      customerId: selectedCustomer?.customerId,
    };
    dispatch(
      userByFilterList({
        body,
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  }, [dispatch]);
  const {
    table: { detail },
  } = useSelector((state) => state?.custUsers);

  return (
    <CustomPageHeader title={<Text t="userManagement" />} showBreadCrumb showHelpButton>
      <UserFilter form={form} />
      {detail !== null && <UserList form={form} />}
    </CustomPageHeader>
  );
};

export default ManagementUser;
